<template>
  <div class="shadow-1 full-height full-width unitCard bg-white">
    <header class="row address q-py-sm">
      <div class="col-2 flex flex-center column">
        <q-icon name="location_city" size="25px">
          <q-tooltip class="bg-indigo">
            {{ allAddressMsg }}
          </q-tooltip>
        </q-icon>
        <div v-if="allAddress.length > 1" class="flex flex-center addres-count">
          {{ allAddress.length }}
        </div>
      </div>
      <div class="col-10">
        <strong>
          {{
            `${addressFind.addressName} - ${addressFind.number} -
              ${addressFind.neighborhood} - ${addressFind.city} -
              ${addressFind.state} - (${addressFind.addressZipCode})`
          }}
        </strong>
      </div>
    </header>
    <main class="q-pa-sm">
      <div class="row q-gutter-sm mb-1" v-if="notUndefined('owner')">
        <q-icon
          style="color: #5f6062"
          class="col-1 flex flex-center"
          name="mdi-account-box-multiple"
          size="25px"
        />
        <span class="col-10">
          <strong>{{ label("owner") }}</strong
          >: {{ value("owner") }} - ({{ value("documentOwner") }})
        </span>
      </div>
      <div class="row q-gutter-sm mb-1" v-if="notUndefined('occupier')">
        <q-icon
          style="color: #5f6062"
          class="col-1 flex flex-center"
          name="mdi-account-box-multiple"
          size="25px"
        />
        <span class="col-10">
          <strong>{{ label("occupier") }}</strong
          >: {{ value("occupier") }} - ({{ value("documentOccupier") }})
        </span>
      </div>
      <div class="row q-gutter-sm" v-if="notUndefined('dweller')">
        <q-icon
          style="color: #5f6062"
          class="col-1 flex flex-center"
          name="mdi-account-box-multiple"
          size="25px"
        />
        <span class="col-10">
          <strong>{{ label("DWELLER") }}</strong
          >: {{ value("dweller") }} - ({{ value("documentDweller") }})
        </span>
      </div>
    </main>
    <q-separator />
    <footer class="tw-p-4">
      <div class="tw-flex tw-justify-between tw-flex-col tw-gap-2">
        <div>
          {{$gettext("START_SERVICE")}}
          <b>{{ moment(this.state.serviceRequests[this.protocol].startDate).format('DD/MM/YYYY HH:MM') }}</b>
        </div>
        <div>
          {{$gettext("WATER_AGREEMENT")}}:
          <b>{{ consumerUnitData.companyCodeWater }}</b>
        </div>
        <div>
          {{$gettext("LEGITIMACY")}}:
          <b>{{ consumerUnitData.lawfulType }}</b>
        </div>
        <div>
          {{ $gettext("UC_CELESC") }}:
          <b>{{ consumerUnitData.infoCad.companyCodeEnergy.value }}</b>
        </div>
        <div>
          {{ $gettext("PROPERTY_SERIAL_NUMBER") }}:
          <b>{{consumerUnitData.propertyRegistration}}</b>
        </div>
        <div>
          {{ $gettext("SIGRE_CODE") }}
          <b>{{ consumerUnitData.sigreCode }}</b>
        </div>
        <div>
          {{ $gettext("METER_NUMBER") }}:
          <b>{{consumerUnitData.hydroNumber}}</b>
        </div>
        <div>
          {{ $gettext("PAYMENT_INSTRUMENT") }}:
          <b>{{consumerUnitData.paymentInstrument}}</b>
        </div>
        <div>
          {{ $gettext("ROUTE") }}:
          <b>{{ consumerUnitData.routeReference }} - {{consumerUnitData.routeShortDescription}}</b>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestModel from '../ServiceRequestModel'
import ServiceRequestController from '../ServiceRequestController'
import moment from 'moment'
@Component({
  name: 'ServiceRequestConsumerUnitCard',
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestConsumerUnitCard extends Vue {
  state = ServiceRequestModel.getInstance();
  controller = ServiceRequestController.getInstance();
  isObservable = true;
  moment = moment

  get addressFind () {
    return this.allAddress.find((a) => a.type == 20030001)
  }

  get consumerUnitData () {
    return this.state.serviceRequests[this.protocol].consumerUnits[
      this.consumerUnit
    ]
  }

  get allAddress () {
    return this.state.serviceRequests[this.protocol].consumerUnits[
      this.consumerUnit
    ].infoCad.address
  }

  get allAddressMsg () {
    let msgAddres = ''
    this.allAddress.forEach((address, i) => {
      msgAddres += `  ${i + 1}: ${address.addressName} - ${address.number} -
              ${address.neighborhood} - ${address.city} -
              ${address.state} - (${address.addressZipCode})`
    })
    return msgAddres
  }

  label (key) {
    if (
      this.state.serviceRequests[this.protocol].consumerUnits[this.consumerUnit]
        .infoCad[key]
    ) {
      return this.state.serviceRequests[this.protocol].consumerUnits[
        this.consumerUnit
      ].infoCad[key].label
    } else return null
  }

  value (key) {
    if (
      this.state.serviceRequests[this.protocol].consumerUnits[this.consumerUnit]
        .infoCad[key]
    ) {
      return this.state.serviceRequests[this.protocol].consumerUnits[
        this.consumerUnit
      ].infoCad[key].value
    } else {
      return null
    }
  }

  notUndefined (key) {
    return !!this.state.serviceRequests[this.protocol].consumerUnits[
      this.consumerUnit
    ].infoCad[key]
  }
}
export default ServiceRequestConsumerUnitCard
</script>
<style lang="stylus" scoped>
.addres-count {
  background-color: red;
  border-radius: 50%;
  height: 15px;
  width: 15px;
  font-size: 11.5px;
  margin-top: -7px;
  position: relative;
  margin-right: -15px;
}

.unitCard {
  font-size: 11.5px;
}

.address {
  background-color: #5898aa;
  color: #fff;
}

.owner {
  margin-left: 10px;
  margin-bottom: 10px;
}

.occupier {
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>
